import { observer } from 'mobx-react'

import { useCurrentLanguage } from 'lib/tolgee'
import { PanelStore } from 'stores'

import { useZaiSideChatIframeModel } from './zai-side-chat-iframe.model'
import { ZaiSideChatIframeView } from './zai-side-chat-iframe.view'

import './zai-side-chat-iframe.styles.scss'

// TODO: Delete this sub-module after isNativeZaiChatEnabled is enabled for all users
const Component = () => {
  const workspaceId = Object(PanelStore?.selectedPanel)?.panelId

  const language = useCurrentLanguage()

  const zaiSideChatModel = useZaiSideChatIframeModel({ workspaceId, language })

  if (!workspaceId || !zaiSideChatModel.shouldRender) return null

  return <ZaiSideChatIframeView {...zaiSideChatModel} />
}

export const ZaiSideChatIframe = observer(Component)
